import { render, staticRenderFns } from "./bargain.vue?vue&type=template&id=69b61d8e&scoped=true&"
import script from "./bargain.vue?vue&type=script&lang=js&"
export * from "./bargain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b61d8e",
  null
  
)

export default component.exports